// extracted by mini-css-extract-plugin
export default {"container":"Rating_container__0LTbo","star":"Rating_star__OHltA","on":"Rating_on__Yx-S2","half":"Rating_half__jImyy"};